import { createSlice } from "@reduxjs/toolkit";
import { defaultArchivedRequestBody, DefaultArchivedRequestBodyType } from "../../../constant/document";
import { fetchArchivedAudios, fetchPaginateArchivedAudios, fetchRefreshArchived, resetArchivedTable, setArchivedAutoRefresh, stopArchivedAutoRefresh, switchArchivedAutoFresh, updateArchivedRequestBody } from "./ArchivedAction";

export interface PaginationType {
  page: number;
  pageSize: number;
  hasMore: boolean;
  loading: boolean;
}

interface AutoRefreshStateType {
  autoRefresh: boolean;
  currentIntervalId: NodeJS.Timer | undefined;
  error: string | undefined;
  loading: boolean;
}

interface ArchivedAudiosStateType {
  data: any;
  loading: boolean;
  error: string | undefined;
  currentRequestBody: DefaultArchivedRequestBodyType;
  pagination: PaginationType;
  autoRefreshArchivedState: AutoRefreshStateType;
  success: boolean;
  message: string;
  currentTenantId: number;
}

const ArchivedAudiosInitialState: ArchivedAudiosStateType = {
  data: [],
  loading: false,
  error: undefined,
  currentRequestBody: defaultArchivedRequestBody,
  pagination: {
    page: 2,
    pageSize: 30,
    hasMore: true,
    loading: false,
  },
  autoRefreshArchivedState: {
    autoRefresh: true,
    currentIntervalId: undefined,
    error: "",
    loading: false,
  },
  success: false,
  message: "",
  currentTenantId: 0,
};

const ArchivedAudiosSlice = createSlice({
  initialState: ArchivedAudiosInitialState,
  name: "transcribe",
  reducers: {},
  extraReducers(builder) {
    builder
      //Fetch Archived data from API
      .addCase(fetchArchivedAudios.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchArchivedAudios.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchArchivedAudios.rejected, (state, action) => {
        state.error = action.error.message;
        // state.error = action.error?.message ?? "";
        state.loading = false;
      })

      //Infinite Scrolling
      .addCase(fetchPaginateArchivedAudios.pending, (state, action) => {
        state.pagination.loading = true;
      })
      .addCase(fetchPaginateArchivedAudios.fulfilled, (state, action) => {
        state.pagination.page = state.pagination.page + 1;
        state.data = state.data.concat(action.payload.data);
        state.pagination.hasMore = action.payload.data.length === state.pagination.pageSize;
        state.pagination.loading = false;
      })
      .addCase(fetchPaginateArchivedAudios.rejected, (state, action) => {
        state.error = action.error.message;
        state.pagination.loading = false;
      })

      //Search InArchived
      .addCase(updateArchivedRequestBody, (state, action) => {
        state.currentRequestBody = action.payload;
      })

      //Reset
      .addCase(resetArchivedTable, (state, action) => {
        return {
          ...ArchivedAudiosInitialState,
          data: state.data,
          autoRefreshArchivedState: state.autoRefreshArchivedState,
        };
      })

      //  Refresh
      .addCase(fetchRefreshArchived.pending, (state, action) => {
        state.autoRefreshArchivedState.loading = true;
      })
      .addCase(fetchRefreshArchived.fulfilled, (state, action) => {
        state.data = action.payload;
        state.autoRefreshArchivedState.loading = false;
      })
      .addCase(fetchRefreshArchived.rejected, (state, action) => {
        state.autoRefreshArchivedState.error = action.error.message;
        state.autoRefreshArchivedState.loading = false;
      })

      //Auto Refresh
      .addCase(setArchivedAutoRefresh, (state, action) => {
        state.autoRefreshArchivedState.currentIntervalId = action.payload.intervalId;
      })
      .addCase(switchArchivedAutoFresh, (state, action) => {
        state.autoRefreshArchivedState.autoRefresh = action.payload.autoRefresh;
      })
      .addCase(stopArchivedAutoRefresh, (state, action) => {
        clearInterval(state.autoRefreshArchivedState.currentIntervalId);
      });
  },
});

export default ArchivedAudiosSlice.reducer;
